import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { toast } from '../ui/Toast';

export function SetName() {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const register = useAuthStore((s) => s.register);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    setBusy(true);
    try {
      await register(trimmed);
      navigate('/onboarding/circle', { replace: true });
    } catch (err) {
      toast(err instanceof Error ? err.message : 'Could not register', 'error');
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-screen-sm flex-col items-center justify-center bg-base px-6 text-text-primary">
      <h1 className="text-2xl font-medium">What can we call you?</h1>
      <p className="mt-2 text-center text-sm text-text-muted">Just a first name. You can change this later.</p>
      <form onSubmit={submit} className="mt-8 w-full max-w-xs">
        <input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={40}
          placeholder="Your name"
          className="w-full rounded-xl border border-border-subtle bg-surface px-4 py-3 text-text-primary outline-none focus:border-sage"
        />
        <button
          type="submit"
          disabled={busy || !name.trim()}
          className="mt-4 w-full rounded-xl bg-sage py-3 text-base font-medium text-white disabled:opacity-50"
        >
          {busy ? 'Setting up…' : 'Continue'}
        </button>
      </form>
    </div>
  );
}
